<div class="container">
  <mat-card appearance="outlined">
    <h2>Impersonation</h2>
    @if (impersonationResponse(); as response) {
      @if (response.success && response.userCredential) {
        <p>
          Impersonation of {{ response.userCredential.user.displayName }} ({{
            response.userCredential.user.email
          }}) successful!<br /><br />Routing to Dashboard...
        </p>
      } @else {
        <p class="error">
          There was an error with impersonation: {{ response.message }}
          <br /><br />Please return to JFW Platform Portal to reattempt.
        </p>
        <button
          mat-flat-button
          color="primary"
          routerLink="/sign-in"
          replaceUrl
        >
          Go to Sign In
        </button>
      }
    } @else {
      <mat-spinner></mat-spinner>
    }
  </mat-card>
</div>
